import { ReactNode } from 'react';
import cn from 'classnames';
import type { Tone } from '../../../domain/psychological-safety/team-result';
import styles from '../InterpretiveReportPage.module.css';

/** A label with its text in the colours of its tone, so colour is never the only signal */
export const ToneChip = ({ tone, children }: { tone: Tone; children: ReactNode }) => (
  <span className={cn(styles.chip, styles[tone])}>{children}</span>
);

const CalloutIcon = ({ tone }: { tone: Tone }) =>
  tone === 'success' ? (
    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" className={styles.calloutIcon}>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M8 12.3l2.8 2.7L16.2 9.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" className={styles.calloutIcon}>
      <path
        d="M12 3.5l9.5 16.5h-19L12 3.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M12 10v4.5M12 17.2v.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );

/** A short verdict with an icon, a lead and a sentence, coloured by its tone */
export const Callout = ({ tone, lead, children }: { tone: Tone; lead: string; children: ReactNode }) => (
  <div className={cn(styles.callout, styles[tone])}>
    <CalloutIcon tone={tone} />
    <span>
      <span className={styles.calloutLead}>{lead}</span> {children}
    </span>
  </div>
);

export const toneClass = (tone: Tone, part: 'Fill' | 'Band' | 'Mean') => styles[`${tone}${part}`];
